import React, { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "@/lib/firebase";
import { ISFUser } from "@/hooks/useUser";
import { toast } from "@/components/ui/use-toast";

interface WalletsProps {
  user: ISFUser;
}

export function Wallets({ user }: WalletsProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [wallets, setWallets] = useState({
    wallet: user.wallet || "",
    solanaWallet: user.solanaWallet || "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleSave = async () => {
    setIsLoading(true);
    try {
      const userRef = doc(db, "users", user.uid);
      await updateDoc(userRef, {
        wallet: wallets.wallet,
        solanaWallet: wallets.solanaWallet,
      });
      setIsEditing(false);
      toast({
        title: "Success",
        description: "Wallet addresses updated successfully",
      });
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to update wallet addresses",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setWallets({
      wallet: user.wallet || "",
      solanaWallet: user.solanaWallet || "",
    });
    setIsEditing(false);
  };

  return (
    <Card className="w-full">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-2xl font-bold">Wallets</CardTitle>
        {!isEditing ? (
          <Button onClick={handleEdit} variant="outline">
            Edit
          </Button>
        ) : (
          <div className="flex gap-2">
            <Button
              onClick={handleCancel}
              variant="outline"
              disabled={isLoading}
            >
              Cancel
            </Button>
            <Button onClick={handleSave} disabled={isLoading}>
              Save
            </Button>
          </div>
        )}
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="space-y-2">
            <label className="text-sm font-medium">Polygon Wallet</label>
            <Input
              placeholder="Enter Polygon wallet address"
              value={wallets.wallet}
              onChange={(e) =>
                setWallets((prev) => ({ ...prev, wallet: e.target.value }))
              }
              disabled={!isEditing}
            />
          </div>
          <div className="space-y-2">
            <label className="text-sm font-medium">Solana Wallet</label>
            <Input
              placeholder="Enter Solana wallet address"
              value={wallets.solanaWallet}
              onChange={(e) =>
                setWallets((prev) => ({
                  ...prev,
                  solanaWallet: e.target.value,
                }))
              }
              disabled={!isEditing}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
